/**
 * Basic Cookie Methods
 */
export const getCookie = cname => {
	try {
		const name = cname + '=';
		const decodedCookie = decodeURIComponent(document.cookie);
		const ca = decodedCookie.split(';');

		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
		}
	} catch (_e) {}

	return '';
};

export const checkCookie = cname => getCookie(cname) !== '';

// add method to check if exists and replace
export const setCookie = (cname, cvalue, exdays = 1) => {
	let d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	var expires = 'expires=' + d.toUTCString();
	document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
};

// add method to remove the cookie
export const removeCookie = cname => {
	if (!checkCookie(cname)) return;
	setCookie(cname, '', -1);
};
